export const Constants = {
  PROJECT: "Festa Seguros",
  PROJECT_DESCRIPTION: "Managing - Portfolios, Programs, Plans and Projects",
};
